import modelEnhance from "@/utils/modelEnhance";
import tokiot from "@/http/tokiot"
import $$ from 'cmn-utils';

export default modelEnhance({
    namespace: "DICT",
    state: {},
    subscriptions: {
        setup({ dispatch, history }) {
            history.listen(({ pathname }) => {
                if (pathname.indexOf('/player') >= 0) {
                    return ``;
                }
                else if (pathname.indexOf('/broadcast/index/bearer') >= 0) {
                    let token = pathname.lastIndexOf('/');
                    if (token >= 0) {
                        token = pathname.substring(token + 1);
                        if (token && token.length > 0) {
                            $$.setStore("headers", { Authorization: token });
                        }
                    }
                } else {
                }
            });
        }
    },
    effects: {
        * init({ payload = {} }, { call, put, select }) {
            const { resolve, data } = payload
            const ret = yield call(tokiot.sys.dict.list, data || {});
            if (ret) {
                const dictList = ret.rows;
                const DICT = {};
                let item = {}
                Object.keys(dictList).map(key => {
                    item = dictList[key];
                    if (DICT[item.type] === undefined) DICT[item.type] = { map: {}, list: [] }
                    DICT[item.type].map[item.value] = item.label;
                    DICT[item.type].list.push({ code: item.value, codeName: item.label });
                })
                $$.setStore('DICT', DICT);
                resolve && resolve(ret)
            }
        },
        * getList({ payload = {} }, { call, put, select }) {
            const { resolve, data } = payload
            const ret = yield call(tokiot.sys.dict.dictList, data || {});
            if (ret) {
                resolve && resolve(ret)
            }
        },
        * getValue({ payload = {} }, { call, put, select }) {
            const { resolve, data } = payload
            const ret = yield call(tokiot.sys.dict.dictValue, data || {});
            if (ret) {
                resolve && resolve(ret)
            }
        },
        * getLabel({ payload = {} }, { call, put, select }) {
            const { resolve, data } = payload
            const ret = yield call(tokiot.sys.dict.dictList, data || {});
            if (ret) {
                resolve && resolve(ret)
            }
        },
        * getDropDownDataByType({ payload = {} }, { call, put, select }) {
            const { resolve, data } = payload
            const ret = yield call(tokiot.sys.dict.dictList, data || {});
            if (ret) {
                resolve && resolve(JSON.parse(JSON.stringify(ret).replace(/label/g, "codeName").replace(/value/g, "code")))
            }
        },
    },
    reducers: {
        commonSuccess(state, { payload }) {
            return { ...state, ...payload };
        }
    }
});
